import React, { useMemo } from 'react';
import { isEmpty } from '@/shared/utility';
import GameCard from '@/pages/games/game-card/GameCard';
import { GamesStreamlineSectionCommonProps } from '@/components/shared/games/GamesStreamlineSection';
import Masonry from '@/components/shared/streamline/children-layouts/Masonry';
import Streamline from '@/components/shared/streamline/Streamline';

const indexes = [0, 3, 6, 9, 12, 15, 18, 21, 24];

function GamesMasonryStreamline({
  games,
  category,
}: GamesStreamlineSectionCommonProps): JSX.Element {
  const children = useMemo(() => {
    const maxChildIndex = games.length - 1;
    const maxFoundIndex = indexes.findIndex(indexInner => indexInner > maxChildIndex);
    const maxIndex = maxFoundIndex === -1 ? indexes[indexes.length - 1] : maxFoundIndex - 1;

    if (isEmpty(games)) return <div />;
    return indexes.slice(0, maxIndex + 1).map(upperIndex => {
      const lowerIndex = upperIndex + 1;
      const largeIndex = upperIndex + 2;
      const upperGame = games[upperIndex];
      const lowerGame = games[lowerIndex];
      const largeGame = games[largeIndex];
      return (
        <Masonry key={`/${category}/${upperGame.slug}/${upperGame.gameId}`}>
          {upperGame && <GameCard game={upperGame} category={category} />}
          {lowerGame && <GameCard game={lowerGame} category={category} />}
          {largeGame && <GameCard large game={largeGame} category={category} />}
        </Masonry>
      );
    });
  }, [games, category]);

  return <Streamline children={children} />;
}

export default GamesMasonryStreamline;
